export default __webpack_public_path__ + "static/media/2.cbf356a0.PNG";